/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-details.reducer';

export const DoctorDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorDetailsEntity = useAppSelector(state => state.doctorDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorDetailsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorDetails.detail.title">DoctorDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.id}</dd>
          <dt>
            <span id="workExperience">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.workExperience">Work Experience</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.workExperience}</dd>
          <dt>
            <span id="dutyStartTime">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.dutyStartTime">Duty Start Time</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.dutyStartTime}</dd>
          <dt>
            <span id="dutyEndTime">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.dutyEndTime">Duty End Time</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.dutyEndTime}</dd>
          <dt>
            <span id="tmPermanent">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.tmPermanent">Tm Permanent</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.tmPermanent}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.modifiedBy}</dd>
          <dt>
            <span id="dob">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.dob">Dob</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.dob}</dd>
          <dt>
            <span id="height">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.height">Height</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.height}</dd>
          <dt>
            <span id="weight">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.weight">Weight</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.weight}</dd>
          <dt>
            <span id="registrationCode">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.registrationCode">Registration Code</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.registrationCode}</dd>
          <dt>
            <span id="registrationNumber">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.registrationNumber">Registration Number</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.registrationNumber}</dd>
          <dt>
            <span id="registrationValidUpto">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.registrationValidUpto">Registration Valid Upto</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.registrationValidUpto}</dd>
          <dt>
            <span id="knownLanguages">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.knownLanguages">Known Languages</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.knownLanguages}</dd>
          <dt>
            <span id="qualification">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.qualification">Qualification</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.qualification}</dd>
          <dt>
            <span id="referredBy">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.referredBy">Referred By</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.referredBy}</dd>
          <dt>
            <span id="bio">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.bio">Bio</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.bio}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.cursor}</dd>
          <dt>
            <span id="practicingCity">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.practicingCity">Practicing City</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.practicingCity}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.gender}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.doctorDetails.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{doctorDetailsEntity.bloodGroup}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorDetails.contactCode">Contact Code</Translate>
          </dt>
          <dd>{doctorDetailsEntity.contactCode ? doctorDetailsEntity.contactCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-details/${doctorDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorDetailsDetail;
